<template>
  <div>
    <div class="footer">
      <div class="use-contain">
        <div>
          <span class="url-common">常用连接</span>
          <div class="linklist flex">
            <a
              :href="item.url"
              v-for="(item, index) in linklist"
              :key="index"
              target="_black"
              :title="item.name"
              >{{ item.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="use-explain">
      <div class="use-contain2">
        <span style="color: #ffffff; margin-top: 0">系统使用说明</span>
        <span style="color: #ffffff; margin-top: 20px"
          >1、本查询系统的信息仅供参考，具体数据请以学校官网或考试院公布为准。</span
        >
        <span style="color: #ffffff; margin-top: 20px"
          >2、本站数据未经授权严禁转载，违者将依法追究责任。</span
        >
        <div
          style="
            border-top: 3px solid #b337e5;
            margin-top: 20px;
            margin-bottom: 20px;
          "
        ></div>
        <span style="color: rgba(255, 255, 255, 0.54); margin-bottom: 40px"
          >鲁ICP备2024080196号-1 Copyright ©
          <span id="year">{{ year }}</span> www.yuanmenggaokao.com ALL right
          reserved . 联系我们 | 法律声明</span
        >
        <div class="qrcode-ym">
          <img
            style="width: 190px; height: 190px"
            src="@/assets/img/qrcode.jpg"
            alt=""
          />
          <span
            style="
              width: 177px;
              height: 16px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              line-height: 55px;
            "
            >欢迎关注圆志愿小程序</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ajaxGetDictItems } from "@/api/api";
import { BaseMixin } from "@/mixins/basemixin";
export default {
  name: "layfooter",
  mixins: [BaseMixin],
  props: {},
  data() {
    return {
      year: "",
      address: "",
      linklist: [
        { name: "山东省教育招生考试院", url: "https://www.sdzk.cn/" },
        { name: "教育部", url: "https://www.moe.gov.cn/" },
        // {
        //   name: "中华人民共和国教育部教育涉外监管信息网",
        //   url: "http://jsj.moe.gov.cn/",
        // },
        { name: "中国教育考试网", url: "https://www.neea.edu.cn/" },
        { name: "阳光高考", url: "https://gaokao.chsi.com.cn/" },
        // {
        //   name: "青岛服务贸易交易公共服务平台",
        //   url: "http://www.spiderplat.cn/Home",
        // },
      ],
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getaddress();
    this.year = new Date().getFullYear();
    // document.getElementById("year").textContent = this.year;
  },
  mounted() {},
  methods: {
    getaddress() {
      ajaxGetDictItems("address").then((res) => {
        // console.log(res);
        if (res.success) {
          this.address = res.result[0].text;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.qrcode-ym {
  position: absolute;
  right: 30px;
  bottom: 162px;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中对齐 */
}
.use-contain {
  width: 1200px;
  margin-bottom: 40px;
}
.use-explain {
  background-color: #660874;
  display: flex;
  justify-content: center;
  align-items: center;
  .use-contain2 {
    width: 1200px;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    position: relative;
  }
}
.url-common {
  width: 80px;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 12px;
}
.footer {
  padding-top: 100px; /* 上方距离为100px */
  padding-bottom: 0; /* 下方距离为0 */
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  //position: relative;
  .linklist {
    //justify-content: center;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
    gap: 10px;
    width: 450px;
    margin-top: 25px;
    //flex-wrap: wrap;
    a {
      margin-left: 0;
      margin-top: 10px;
      font-size: 14px;
      color: #333;
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        color: #660874;
      }
    }
  }
  .reference {
    margin: 10px 0 10px 0;
    justify-content: center;
    span {
      margin: 0 10px;
    }
    a {
      font-size: 14px;
      color: #333;
    }
  }
  .address {
    text-align: center;
    font-size: 14px;
  }
  .copy {
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
  }
}
</style>
